import { initializeSentry } from './services/sentry.service';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { configure } from 'mobx';

initializeSentry();

setTimeout(() =>
  configure({
    // enforceActions: 'never',
    useProxies: 'never',
    enforceActions: 'always',
    computedRequiresReaction: true,
    reactionScheduler: f => setTimeout(f)
  })
);

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
